import React from "react"
import { AppBasicTable } from "@components"
import {
	analyzersColumn,
	checkerColumn,
	dateColumn,
	downloadColumn,
	globalDownloadColumn,
	statusColumn
} from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History/Table/columns"


export default function ReportListHistoricalModalContentTable({ reportName, data, officeSelected }) {

	return <AppBasicTable
		sx={{ maxHeight: 400, borderRadius: 1 }}
		// inside a dialog: no card of its own around the table
		cardProps={{ sx: { border: 0, boxShadow: 'none', backgroundColor: 'transparent', '&:hover': { boxShadow: 'none' }, '& .MuiCardHeader-root': { display: 'none' }, '& .MuiCardContent-root': { p: 0, '&:last-child': { pb: 0 } } } }}
		toolbarProps={{ actions: false }}
		data={data}
		headers={[[
			{ label: 'Date' },
			{ label: 'Status' },
			{ label: 'Exported' },
			{ label: 'Mailed' },
			{ label: 'Opened' },
			{ label: 'Links' },
			{ label: 'Download' },
			{ label: 'Global Download' },
		]]}
		columns={[
			dateColumn(),
			statusColumn(),
			checkerColumn('exported'),
			checkerColumn('mailed'),
			checkerColumn('opened'),
			analyzersColumn(officeSelected),
			downloadColumn(),
			globalDownloadColumn(),
		]}
	/>
}